import { ReactElement, useEffect, useRef } from 'react';

import { LocalStackEventType } from '../constants';

interface Props {
  children: ReactElement;
}

export const ResizerHandler = ({ children }: Props): ReactElement => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const height = entry.contentRect.height;
        window.parent.postMessage({ eventType: LocalStackEventType.SET_HEIGHT, data: { height: `${height}px` } }, '*');
      }
    });

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={contentRef} id="resizer-handler-page-content">
      {children}
    </div>
  );
};
